// The jump bar's app-wide state: whether it is open, the subject the page
// shows, and the signed-in user's recents and pins (jump/places.svelte.ts,
// which the repository index reads its pinned repositories from). One bar, in App; the
// top bar's button and the jump key open it.
import { session } from '../state/session.svelte';
import { onLocalStateCleared } from '../state/prefs.svelte';
import { Places, PLACES_PREFIX } from './places.svelte';

/** The signed-in user's recents and pins. */
export const places = new Places({
  storage: () => {
    try {
      return typeof localStorage === 'undefined' ? null : localStorage;
    } catch {
      return null;
    }
  },
  login: () => session.user?.login ?? null,
  // Another tab's change to them (or to every key, `clear()`).
  listen: (changed) => {
    if (typeof window === 'undefined') return () => {};
    const on = (e: StorageEvent) => {
      if (e.key === null || e.key.startsWith(PLACES_PREFIX)) changed();
    };
    window.addEventListener('storage', on);
    return () => window.removeEventListener('storage', on);
  },
});

// The user's local state was deleted (sign-out, or another account claimed the browser): what this page holds of it goes too.
onLocalStateCleared(() => places.refresh());

class JumpUi {
  open = $state(false);
  /** The key of the subject the page shows (a history's once its page resolved it): no place to jump to. */
  here: string | null = $state(null);
  show() {
    this.open = true;
  }
  close() {
    this.open = false;
  }
}

export const jumpUi = new JumpUi();
